/* eslint-disable
    func-names,
    no-shadow,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
const deps = ['Model'];
const factory = function (Model) {
  let Address;
  return (Address = (function () {
    Address = class Address extends Model {
      static initClass() {
        this.prototype.$resource = 'address';

        this.prototype.id = null;
        this.prototype.streetLine1 = '';
        this.prototype.streetLine2 = '';
        this.prototype.city = '';
        this.prototype.province = '';
        this.prototype.postalCode = '';
        this.prototype.contactPersonFirstName = '';
        this.prototype.contactPersonLastName = '';
        this.prototype.phone = '';
        this.prototype.countryId = null;
      }
    };
    Address.initClass();
    return Address;
  })());
};

factory.$inject = deps;

const moduleDeps = [require('data/util').name];

module.exports = angular.module('bench.data.model.address', moduleDeps).factory('Address', factory);
